import { useEffect, useRef, useState } from 'react';
import { fetchAllMetaPages, fetchMetaInsights } from '../../services/meta-api.js';
import { makeTrendPoints } from './meta-growth-intelligence.js';
import { WorkbenchHead, amount } from './MetaWorkbenchUi.jsx';

export default function MetaDailyTrend({ range, currency }) {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [stale, setStale] = useState(false);
  const requestId = useRef(0);
  useEffect(() => {
    requestId.current += 1;
    setRows([]);
    setError('');
    setStale(false);
    setLoading(false);
  }, [range.dateFrom, range.dateTo]);
  async function load() {
    const id = ++requestId.current;
    setLoading(true); setError('');
    try {
      let returnedStale = false;
      const result = await fetchAllMetaPages(fetchMetaInsights, {
        level: 'account', timeIncrement: 1, since: range.dateFrom, until: range.dateTo
      }, 100, (page) => { if (page.stale) returnedStale = true; });
      if (id === requestId.current) {
        setStale(returnedStale);
        setRows(result.slice().sort((a, b) => String(a.dateStart).localeCompare(String(b.dateStart))));
      }
    } catch (e) {
      if (id === requestId.current) setError(e.message || 'No fue posible obtener la evolución.');
    } finally {
      if (id === requestId.current) setLoading(false);
    }
  }
  const spend = makeTrendPoints(rows, (r) => r.spend);
  const spendPath = spend.map((p) => p.x + ',' + p.y).join(' ');
  const maxSpend = Math.max(0, ...rows.map((r) => Number(r.spend || 0)));
  return <section className="mgw-panel">
    <WorkbenchHead number="06" title="Evolución diaria de inversión" description="Datos reales · Meta Insights" />
    <div className="mgw-panel-toolbar">
      <p>Se consulta solamente cuando la pedís, para cuidar el límite de Meta.</p>
      <button type="button" className="mgw-btn is-secondary" onClick={load} disabled={loading}>
        {loading ? 'Consultando…' : rows.length ? 'Actualizar evolución' : 'Ver evolución'}
      </button>
    </div>
    {error ? <p className="mgw-alert">{error}</p> : null}
    {stale ? <p className="mgw-alert">Serie recuperada de caché por límites de Meta; puede no estar actualizada.</p> : null}
    {rows.length > 1 ? <div className="mgw-chart">
      <svg viewBox="0 0 720 193" role="img" aria-label="Evolución diaria del gasto Meta en el rango seleccionado" preserveAspectRatio="none">
        <line x1="0" y1="155" x2="720" y2="155" stroke="#d8e2ed" strokeWidth="1" />
        <line x1="0" y1="83" x2="720" y2="83" stroke="#eef2f7" strokeWidth="1" />
        <polyline points={spendPath} fill="none" stroke="#3267ad" strokeWidth="2.5" vectorEffect="non-scaling-stroke" />
        {spend.map((point, i) => <circle key={i} cx={point.x} cy={point.y} r="3" fill="#3267ad">
          <title>{String(rows[i].dateStart || '') + ': ' + amount(point.value, currency)}</title>
        </circle>)}
        <text x="1" y="182" className="mgw-svg-label">{rows[0].dateStart}</text>
        <text x="720" y="182" textAnchor="end" className="mgw-svg-label">{rows[rows.length - 1].dateStart}</text>
      </svg>
      <div className="mgw-chart-footer"><span>Máximo diario: <strong>{amount(maxSpend, currency)}</strong></span><span>{rows.length} días con datos</span></div>
    </div> : rows.length === 1 ? <p className="mgw-muted">Solo hay un día disponible. Inversión: {amount(rows[0].spend, currency)}</p> : null}
  </section>;
}

